import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { CommissionIndicator } from '@/experiences/sales-portal/domain/ordering/containers/checkout-panel/components/commission-indicator';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface CheckoutPanelTotalSummaryProps {
  commissionDisplayValue?: string | null;
  isLoading: boolean;
  totalAmount?: string;
}

export const CheckoutPanelTotalSummary: React.FC<
  CheckoutPanelTotalSummaryProps
> = ({ commissionDisplayValue, totalAmount, isLoading }) => {
  const [styles, theme] = useStyles();

  if (isLoading) {
    return (
      <View style={[styles.totalContainer, styles.totalLoadingContainer]}>
        <AnimatedSkeletonLoader borderRadius={20} height={16} width={40} />
        <AnimatedSkeletonLoader borderRadius={20} height={18} width={80} />
      </View>
    );
  }

  return (
    <View style={styles.totalContainer}>
      <View style={styles.totalLabelRow}>
        <Typography
          color={theme.sk.color.text.primary}
          variant="paragraph-base"
        >
          {i18n.t('total')}
        </Typography>
        {commissionDisplayValue ? (
          <CommissionIndicator displayValue={commissionDisplayValue} />
        ) : null}
      </View>
      <View style={styles.totalAmountRow}>
        <Typography color={theme.sk.color.text.primary} variant="heading-md">
          {totalAmount}
        </Typography>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  totalAmountRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
  },
  totalContainer: {
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  totalLabelRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
  totalLoadingContainer: {
    gap: theme.sk.spacing.spaceSMedium,
    paddingTop: theme.sk.spacing.spaceSmall,
  },
}));
